export default __webpack_public_path__ + "static/media/Feedback.6d0f09f9.svg";